<script lang="ts">
	import OttoUpLogo from '$elements/OttoUpLogo.svelte';
	import AchievementsCinema from '$components/up-achievements/AchievementsCinema.svelte';
	import PointsProgress from '$components/up-achievements/PointsProgress.svelte';
	import { getCurrentThreshold } from '$services/PointsService';

	const { points }: { points: number } = $props();
	const pointThreshold = $derived.by(() => {
		return getCurrentThreshold(points);
	});
</script>


<div class="up-achievements-container oc-pt-100 oc-pb-150" data-testid="up-achievements-container">
	<div class="up-achievement-container__headline oc-px-100 oc-pb-75">
		<div
			class="oc-headline-100 oc-headline-100--s oc-headline-100--m oc-headline-200--l oc-headline-200--xl oc-headline-200--xxl">
			Deine Chance auf Extra-Punkte
		</div>
		<OttoUpLogo />
	</div>
	<PointsProgress points={points} pointThreshold={pointThreshold} />
	<AchievementsCinema />
</div>

<style lang="scss">
  .up-achievement-container {
    &__headline {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>
